import { render, staticRenderFns } from "./CtcPendingVerifications.vue?vue&type=template&id=6747c51e&scoped=true&"
import script from "./CtcPendingVerifications.vue?vue&type=script&lang=js&"
export * from "./CtcPendingVerifications.vue?vue&type=script&lang=js&"
import style0 from "./CtcPendingVerifications.vue?vue&type=style&index=0&id=6747c51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747c51e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
